import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  EditInvoiceArrivalRootParamList,
  InvoiceAddProductModalRootScreenParamList,
} from "../../../../types";
import {
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { AddProductModalScreen } from "../AddProductModalScreen";
import { SelectProductModalScreen } from "../SelectProductModalScreen";
import { SuggestType } from "@towersystems/roam-common/lib/generated-types";
import { useFullTextSearch } from "../../../../utilities/fulltext-search";
import { FulltextProductSearchContext } from "../../../../utilities/fulltext-search/context";
import { useSelectedProduct } from "../../utils/selected-product/hooks";
import { SelectedProductContext } from "../../utils/selected-product/context";
import { AddNonProductModalScreen } from "../AddNonProductModalScreen";
import { useDatabase } from "@nozbe/watermelondb/hooks";
import ProductModel from "../../../../utilities/data/model/Product";
import { ProductFormActionsContext } from "../../../products/components/ProductForm/context";
import { CreateProductRootScreen } from "../../../products/screens/CreateProductRootScreen";
import { EditProductRootScreen } from "../../../products/screens";
import { useListFilter } from "../../../../utilities/list-filter";
import { ProductsFilterValues } from "../../../products/types";
import { defaultProductFilterValues } from "../../../products/common";
import { ListFilterProvider } from "../../../../utilities/list-filter/use-list-filter-context";
import { ProductListFilterRootScreen } from "../../../products/screens/ProductListFilterRootScreen";
import { useInvoiceArrivalContextProvider } from "../../utils/active-invoice-arrival";

const Drawer =
  createStackHeaderNavigator<InvoiceAddProductModalRootScreenParamList>();

export type AddProductModalRootScreenProps =
  StackScreenProps<EditInvoiceArrivalRootParamList>;

export const AddProductModalRootScreen =
  ({}: AddProductModalRootScreenProps) => {
    const database = useDatabase();

    const selectedProductContext = useSelectedProduct();
    const { invoiceArrival } = useInvoiceArrivalContextProvider();

    const fullTextSearch = useFullTextSearch({
      type: SuggestType.PRODUCT,
      responseType: "complete",
      activeOnly: true,
    });

    const filterContext = useListFilter<ProductsFilterValues>({
      defaultValues: {
        ...defaultProductFilterValues,
        supplierIds: [invoiceArrival.supplierId],
      },
    });

    return (
      <ListFilterProvider {...filterContext}>
        <SelectedProductContext.Provider value={selectedProductContext}>
          <FulltextProductSearchContext.Provider value={fullTextSearch}>
            <ProductFormActionsContext.Provider
              value={{
                onAfterAddProduct: async (product) => {
                  try {
                    const newProduct = await database
                      .get<ProductModel>("products")
                      .find(product.id);
                    selectedProductContext.setProduct(newProduct);
                  } catch (err) {
                    console.log(err);
                  }
                },
              }}
            >
              <Drawer.Navigator
                screenOptions={{
                  animationEnabled: true,
                  cardStyleInterpolator:
                    CardStyleInterpolators.forHorizontalIOS,
                  headerLeft: () => <ModalCloseButton type="Close" />,
                }}
              >
                <Drawer.Group>
                  <Drawer.Screen
                    name="SelectProductModalScreen"
                    component={SelectProductModalScreen}
                  />
                </Drawer.Group>
                <Drawer.Group
                  screenOptions={{
                    headerLeft: () => <ModalCloseButton type="Back" />,
                    title: "",
                  }}
                >
                  <Drawer.Screen
                    name="AddProductModalScreen"
                    component={AddProductModalScreen}
                  />
                  <Drawer.Screen
                    name="AddNonProductModalScreen"
                    component={AddNonProductModalScreen}
                  />
                </Drawer.Group>
                <Drawer.Group
                  screenOptions={{
                    headerShown: false,
                  }}
                >
                  <Drawer.Screen
                    name="CreateProductRootScreen"
                    component={CreateProductRootScreen}
                  />
                </Drawer.Group>
                <Drawer.Group
                  screenOptions={{
                    headerShown: false,
                    presentation: "modal",
                    title: "",
                  }}
                >
                  <Drawer.Screen
                    name="EditProductRootScreen"
                    component={EditProductRootScreen}
                  />
                  <Drawer.Screen
                    name="ProductListFilterRootScreen"
                    component={ProductListFilterRootScreen}
                  />
                </Drawer.Group>
              </Drawer.Navigator>
            </ProductFormActionsContext.Provider>
          </FulltextProductSearchContext.Provider>
        </SelectedProductContext.Provider>
      </ListFilterProvider>
    );
  };
